import React from 'react';
import { useUserToken } from '../../../hooks/useToken';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const Redirect = ({ redirectTo = '/user/dashboard' }) => {
  const { token } = useUserToken();

  if (!token) {
    return <Navigate to={'/login'} />;
  }
  return <Navigate to={redirectTo} />;
};

Redirect.propTypes = {
  redirectTo: PropTypes.string,
};

export default Redirect;
